export const theses2021 = [
  {
    id: 1,
    thesis:
      "Launch Tinvio Checkout ™ for on-platform payments, supplier web dashboard, and more",
    thesis1440:
      "Launch Tinvio Checkout for on-platform payments, supplier web dashboard and more",
  },
  {
    id: 2,
    thesis:
      "Series A funding to launch embedded finance capabilities for our supply chains",
    thesis1440:
      "Series A funding to build embedded supply chain financing products for our users",
  },
  {
    id: 3,
    thesis:
      "Expand into new verticals and markets. Close the year with 150 team members and 4000+ active businesses across the region",
    thesis1440:
      "Expand into new verticals and markets. Close the year with 200 team members and 4000+ active businesses across the region",
    thesis375: [
      "Expand into new verticals and markets. Close the year with 200 team members and 4000+ active businesses across \nthe region",
    ],
  },
];

export const theses2020 = [
  {
    id: 1,
    thesis: "Seed funding led by Sequoia and GFC",
    thesis1440: "Seed funding led by Sequoia, GFC",
  },
  {
    id: 2,
    thesis: "Launch multi-country localization, digital invoicing, and more",
    thesis1440: "Launch multi-country localization, digital invoicing and more",
  },
  {
    id: 3,
    thesis:
      "Adapt to Covid-19. Triple team size to 75. Activate 1000+ new businesses",
    thesis1440:
      "Adapt to Covid-19. Triple our team size to 100. Activate 1000+ new businesses",
  },
];

export const theses2019 = [
  {
    id: 1,
    thesis:
      "Our founder Ajay raises pre-seed in Europe. Moves back to Singapore to build Tinvio",
    thesis1440:
      "Our founder Ajay raises pre-seed in Europe. Moves back home to Singapore to start Tinvio",
  },
  {
    id: 2,
    thesis:
      "Zero to one in team, product, processes. Launch merchant mobile app in 2 months",
    thesis1440:
      "Zero to one in team, product, processes. Launch merchant mobile app",
  },
  {
    id: 3,
    thesis:
      "Ajay meets our COO Tedo. Swiftly expand into Indonesia and more markets",
    thesis1440:
      "Ajay meets our COO Tedo. Expand into Indonesia and more markets ",
  },
];
